module.exports = __webpack_public_path__ + "Lato-LightItalic.269a8263dd056cd7c9a9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-LightItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato-LightItalic.ttf
// module chunks = styles